'use strict';

var Reflux   = require('reflux'),
    Promise  = require('bluebird'),
    _ = require('underscore'),
    defaults = require('superagent-defaults'),
    request  = require('superagent-promise'),
    TagSearchStore = require('js/shared/stores/tagsearch-store.js'),
    HACKATHONS = require('js/shared/utils/events.js'),
    Country  = require('js/shared/utils/country.js');


var TRAVEL = require('js/shared/utils/travel.js');

var request = defaults(request);

request.set('X-Requested-With', 'XMLHttpRequest')
       .type('application/json')
       .accept('application/json');

var doTrim = function(inp) {
 if (inp) {
   return inp.trim();
 }
 return inp;
};

var ApplicationActions = Reflux.createActions({

    updateField: { },
    changeStage: { },
    completeForm: { },
    nextQuestionPage: { },
    setInitialValues: { },
    changeQuestionPage: { },
    submitError: { },
    homepageClick: { },

    submitEdit: { asyncResult: true, children: ['progressed'] },

    // PRIVATE ACTIONS -- do not use outside of this file.
    __createUser: { asyncResult: true, children: ['progressed'] },
    __authUser: { asyncResult: true, children: ['progressed'] },
    __createClaim: { asyncResult: true, children: ['progressed'] },

    __updateUser: { asyncResult: true, children: ['progressed'] },
    __updateClaim: { asyncResult: true, children: ['progressed'] },

    createNewSchool: { asyncResult: true, children: ['progressed'] },

    refreshApplication: { asyncResult: true, children: ['progressed'] },

    submitApplication: { asyncResult: true, children: ['progressed'] },

    searchUniversities: { asyncResult: true, children: ['progressed'] },

    viewVotePage
    : {},

    submitVotes: { asyncResult: true, children: ['progressed'] },
    updateResume: { asyncResult: true, children: ['progressed'] },

    submitVotePage: { asyncResult: true, children: ['progressed'] },
    submitWaiverPage: { asyncResult: true, children: ['progressed'] },
    submitAdditionalPage: { asyncResult: true, children: ['progressed'] },
    submitResumePage: { asyncResult: true, children: ['progressed'] },
    submitTravelPage: { asyncResult: true, children: ['progressed'] },
    submitWaitlistedTravelPage: { asyncResult: true, children: ['progressed'] },
    withdrawApplication: { asyncResult: true, children: ['progressed'] }
});

ApplicationActions.submitEdit.listen(function (token, props) {
    var data = props.application.values;
    var UPDATE_USER_PAYLOAD = {
        full_name : doTrim(data.name),
        email: doTrim(data.email),
        school_email : doTrim(data.school_email),
        interests: data.skills, // :( bad naming
        hackathons: _.map(data.hackathons, function(hackathon) {
            var slug = HACKATHONS.hackathonToSlugMapping[hackathon];
            if (slug !== undefined) {
                return slug;
            }
            else {
                return hackathon;
            }
        }),
        education : {
            program: data.academic_program,
            institution : data.institution,
            graduating_year : data.academic_year,
            current_status : data.current_status
        },
        travel : {
            current_city : doTrim(data.current_city)
        },
        demographics : {
            gender: data.gender
        },
        url : {
            github: doTrim(data.github),
            linkedin: doTrim(data.linkedin),
            portfolio: doTrim(data.portfolio)
        }
    };
    var UPDATE_CLAIM_PAYLOAD = {
        fields: {
            '2'   : data.first_hackathon,
            '6'   : data.interests,
            '1342': data.travel_reimbursements,
            '1343': data.cool_story_bro,
            '1344': data.age,
            '1346': data.has_idea,
            '1347': data.hardware_hack,
            '1348': data.did_attend_htn,
            '1349': data.team_disclaimer
        }
    };

    // deal with users who dont press enter after each item :(
    // for skills
    var unenteredInterests = [];
    if (props.application.tagTextInput.skills !== undefined) {
        unenteredInterests = props.application.tagTextInput.skills.split(",").map(function(text){ return text.trim(); }).filter(function(text) { return text !== ""; });
    }
    UPDATE_USER_PAYLOAD.interests = UPDATE_USER_PAYLOAD.interests.concat(unenteredInterests);
    // for hackathons
    var unenteredHackathons = [];
    if (props.application.tagTextInput.hackathons !== undefined) {
        unenteredHackathons = props.application.tagTextInput.hackathons.split(",").map(function(text) { return text.trim(); }).filter(function(text) { return text !== ""; });
    }
    UPDATE_USER_PAYLOAD.hackathons = UPDATE_USER_PAYLOAD.hackathons.concat(unenteredHackathons);

    if (UPDATE_CLAIM_PAYLOAD.fields['1349']) {
        UPDATE_CLAIM_PAYLOAD.fields['1349'] = UPDATE_CLAIM_PAYLOAD.fields['1349'].indexOf('understand') !== -1;
    }

    if (UPDATE_CLAIM_PAYLOAD.fields['6'] === "" || !UPDATE_CLAIM_PAYLOAD.fields['6']) {
        UPDATE_CLAIM_PAYLOAD.fields['6'] = [];
    }
    else if (!Array.isArray(UPDATE_CLAIM_PAYLOAD.fields['6'])) {
        UPDATE_CLAIM_PAYLOAD.fields['6'] = [data.interests];
    }

    /**
     * Clean up the values for the API (blegh)
     */
    for (var key in UPDATE_USER_PAYLOAD) {
        if (UPDATE_USER_PAYLOAD[key] === undefined) {
            UPDATE_USER_PAYLOAD[key] = null;
        }
        // check if object and nested keys
        else if (UPDATE_USER_PAYLOAD[key] === Object(UPDATE_USER_PAYLOAD[key])) {
            for (var subkey in UPDATE_USER_PAYLOAD[key]) {
                if (UPDATE_USER_PAYLOAD[key][subkey] === undefined) {
                    UPDATE_USER_PAYLOAD[key][subkey] = null;
                }
            }
        }

    }
    for (var key in UPDATE_CLAIM_PAYLOAD.fields) {
        if (UPDATE_CLAIM_PAYLOAD.fields[key] === undefined) {
            UPDATE_CLAIM_PAYLOAD.fields[key] = null;
        }
    }

    var radioQuestions = ['1344', '1346', '1347', '1342', '2', '1348', '1349'];
    _.forEach(radioQuestions, function(question) {
        if (UPDATE_CLAIM_PAYLOAD.fields[question] === "No") {
            UPDATE_CLAIM_PAYLOAD.fields[question] = false;
        }
        else if (UPDATE_CLAIM_PAYLOAD.fields[question] === "Yes") {
            UPDATE_CLAIM_PAYLOAD.fields[question] = true;
        }
    });

    if (props.application.no_claim_found) {
        UPDATE_CLAIM_PAYLOAD.name = doTrim(data.name);
    }

    this.promise(new Promise(function (resolve, reject) {
        ApplicationActions.__updateUser({
            payload: UPDATE_USER_PAYLOAD,
            user_id : props.api.user_id,
            token: token
        }).then(function (resp1) {
            if (resp1.body.success === false) {
                reject([resp1]);
                return;
            }
            ApplicationActions.__updateClaim({
                payload: UPDATE_CLAIM_PAYLOAD,
                token: token,
                claim_id : props.api.claim_id,
                no_claim: props.application.no_claim_found,
            }).then(function (resp2) {
                if (resp2.body.success === false) {
                    reject([resp1, resp2]);
                    return;
                }
                else {
                    resolve([resp1, resp2]);
                }
            }).catch(function(error) {
                reject([error]);
            });
        }).catch(function(error) {
            reject([error]);
        });
    }));
});

ApplicationActions.__updateUser.listen(function (options) {
    return request
        .put('https://hackerapi.com/v1/users/'+options.user_id+'?token=' + options.token)
        .send(options.payload)
        .end()
        .then(function (resp) {
            if (typeof resp.body.success !== 'undefined' && !resp.body.success) {
                ApplicationActions.__updateUser.failed(resp);
            } else {
                ApplicationActions.__updateUser.completed(resp);
            }
        })
        .catch(function(error) {
            ApplicationActions.__updateUser.failed(error);
        });
});

ApplicationActions.__updateClaim.listen(function (options) {
    var temp_promise;
    if (options.no_claim) {
        temp_promise = request.post('https://hackerapi.com/v1/pipelines/1/claims?token=' + options.token);
    }
    else {
        temp_promise = request.put('https://hackerapi.com/v1/claims/'+options.claim_id+'?token=' + options.token);
    }
    return temp_promise
        .send(options.payload)
        .end()
        .then(function (resp) {
            if (typeof resp.body.success !== 'undefined' && !resp.body.success) {
                ApplicationActions.__updateClaim.failed(resp);
            } else {
                ApplicationActions.__updateClaim.completed(resp);
            }
        })
        .catch(function(error) {
            ApplicationActions.__updateClaim.failed(error);
        });
});



/**
 * Submits an application. Someone thought it was a good idea to make
 * this a three step process and so here we are.
 *
 * Args:
 *     options.application: Everything about the application
 */
ApplicationActions.submitApplication.listen(function (options) {

    var values = options.application.values;

    var CREATE_USER_PAYLOAD = {
        full_name: values.name.trim(),
        email: values.email.trim(),
        password: values.password,
        url : {
            portfolio : values.portfolio
        },
        education: {
            institution_id: values.institution,
            current_status: values.current_status,
            graduating_year: values.academic_year
        }
    };

    var AUTH_USER_PAYLOAD = {
        username: values.email.trim(),
        password: values.password
    };

    var CREATE_CLAIM_PAYLOAD = {
        name: values.name,
        fields: {
            "2" : values.first_hackathon !== 'No',
            "1342": values.travel_reimbursements !== 'No',
            "1343": values.cool_story_bro
        }
    };

    this.promise(new Promise(function (resolve, reject) {
        ApplicationActions.__createUser({
            payload: CREATE_USER_PAYLOAD
        }).then(function (resp) {
            if (resp.body.success === false) {
                reject(resp);
                return;
            }
            ApplicationActions.__authUser({
                payload: AUTH_USER_PAYLOAD
            }).then(function (resp) {
                if (resp.body.success === false) {
                    reject(resp);
                    return;
                }
                ApplicationActions.__createClaim({
                    payload: CREATE_CLAIM_PAYLOAD,
                    auth_token: resp.body.token
                }).then(function (resp) {
                    if (resp.body.success === false) {
                        reject(resp);
                    } else {
                        resolve(resp);
                    }
                }).catch(function(error) {
                    reject(error);
                });
            }).catch(function(error) {
                reject(error);
            });
        }).catch(function(error) {
            reject(error);
        });
    }));

});

ApplicationActions.__createUser.listen(function (options) {
    return request
        .post('https://hackerapi.com/v1/users')
        .send(options.payload)
        .end()
        .then(function (resp) {
            if (typeof resp.body.success !== 'undefined' && !resp.body.success) {
                ApplicationActions.__createUser.failed(resp);
            } else {
                ApplicationActions.__createUser.completed(resp);
            }
        }).catch(function(error) {
            ApplicationActions.__createUser.failed(error);
        });
});

ApplicationActions.__authUser.listen(function (options) {
    return request
        .post('https://hackerapi.com/v1/auth/user')
        .send(options.payload)
        .end()
        .then(function (resp) {
            if (typeof resp.body.success !== 'undefined' && !resp.body.success) {
                ApplicationActions.__authUser.failed(resp);
            } else {
                ApplicationActions.__authUser.completed(resp);
            }
        }).catch(function(error) {
            ApplicationActions.__authUser.failed(error);
        });
});

ApplicationActions.__createClaim.listen(function (options) {
    return request
        .post('https://hackerapi.com/v1/pipelines/1/claims?token=' + options.auth_token)
        .send(options.payload)
        .end()
        .then(function (resp) {
            if (typeof resp.body.success !== 'undefined' && !resp.body.success) {
                ApplicationActions.__createClaim.failed(resp);
            } else {
                ApplicationActions.__createClaim.completed(resp);
            }
        }).catch(function(error) {
            ApplicationActions.__createClaim.failed(error);
        });
});


ApplicationActions.refreshApplication(function (options) {
    // probably onStageSwitch or something like that
    // needs to be called with auth token in arguments
    return this.promise(request
        .get("<url>?auth_token=" + options.auth_token)
        .end()
    );
});

ApplicationActions.setInitialValues.listen(function(values) {
});

ApplicationActions.searchUniversities.listen(function (searchQuery) {
    this.promise(request
        .get('https://hackerapi.com/v1/search/institutions')
        .query({
            q: searchQuery
        })
        .end()
    );
});

ApplicationActions.createNewSchool.listen(function (schoolName, country, institutionType) {
    this.promise(request
        .post('https://hackerapi.com/v1/institutions')
        .send({
            name: schoolName,
            country_code: Country.getCountryCode(country),
            institution_type: institutionType
        })
        .end()
    );
});

ApplicationActions.submitWaiverPage.listen(function (token, application) {
    var data = application.values;

    var format_dob = function(inp) {
        if(inp) {
            var s = inp.split('/');
            var y = s[2] + '-';
            var m = s[1] + '-';
            var d = ('0' + s[0]).slice(-2);
            return y+m+d;
        }
    }

    var UPDATE_USER_PAYLOAD = {
        'phone_number': data.waiver_phone,
        'demographics': {
            'date_of_birth': format_dob(data.waiver_dob),
        },
        'address': {
            'line_1': data.waiver_address_line1,
            'line_2': data.waiver_address_line2,
            'city': data.waiver_address_city,
            'state_province': data.waiver_address_state,
            'country': data.waiver_address_country,
            'country_code': Country.getCountryCode(data.waiver_address_country),
            'zip_postal_code': data.waiver_address_zipcode,
        },
        'emergency_contact': {
            'phone_number': data.waiver_emerg_phone,
            'full_name': data.waiver_emerg_name
        },
    };


    var cf_fields = {
            '1362': data.waiver_youth === undefined ? undefined : JSON.stringify(data.waiver_youth),
            '1365': data.age2,
            '1366': data.waiver_legal_name,
            '1367': data.waiver_parental_name,
            '1368': data.waiver_parental_email,
            '1369': (new Date()).toISOString(),
            '1370': data.waiver_emerg_email,
            '1371': data.waiver_phone,
            '1372': data.waiver_emerg_relationship
        }


    var UPDATE_CLAIM_PAYLOAD = { fields: cf_fields}

    // ensures no undefined go through. they instead aren't in the PUT
    // should we instead delete it?
    for (var key in UPDATE_CLAIM_PAYLOAD.fields) {
        if (UPDATE_CLAIM_PAYLOAD.fields[key] === undefined) {
            delete UPDATE_CLAIM_PAYLOAD.fields[key];
        }
    }

    var radioQuestions = ['1365'];
    _.forEach(radioQuestions, function(question) {
        if (UPDATE_CLAIM_PAYLOAD.fields[question] === "No") {
            UPDATE_CLAIM_PAYLOAD.fields[question] = false;
        }
        else if (UPDATE_CLAIM_PAYLOAD.fields[question] === "Yes") {
            UPDATE_CLAIM_PAYLOAD.fields[question] = true;
        }
    });

    this.promise(new Promise(function (resolve, reject) {
        ApplicationActions.__updateUser({
            payload: UPDATE_USER_PAYLOAD,
            user_id : application.user_id,
            token: token
        }).then(function (resp1) {
            if (resp1.body.success === false) {
                reject([resp1]);
                return;
            }
            ApplicationActions.__updateClaim({
                payload: UPDATE_CLAIM_PAYLOAD,
                token: token,
                claim_id : application.claim_id,
            }).then(function (resp2) {
                if (resp2.body.success === false) {
                    reject([resp1, resp2]);
                    return;
                }
                else {
                    resolve([resp1, resp2]);
                }
            }).catch(function(error) {
                reject([error]);
            });
        }).catch(function(error) {
            reject([error]);
        });
    }));
});

ApplicationActions.submitAdditionalPage.listen(function (token, application) {
    var data = application.values;
    var UPDATE_USER_PAYLOAD = {
        'shirt_size': data.additional_shirt, // int
        'food_restrictions': data.additional_food_restrictions, // list of string
    };

    var UPDATE_CLAIM_PAYLOAD = {
        fields: {
            '1364': data.additional_food_other, // string
            '1361': data.additional_hardware
        }
    };

    // ensures no undefined go through. they instead aren't in the PUT
    // should we instead delete it?
    for (var key in UPDATE_CLAIM_PAYLOAD.fields) {
        if (UPDATE_CLAIM_PAYLOAD.fields[key] === undefined) {
            delete UPDATE_CLAIM_PAYLOAD.fields[key];
            // delete UPDATE_CLAIM_PAYLOAD.fields[key] = null;
        }
    }

    this.promise(new Promise(function (resolve, reject) {
        ApplicationActions.__updateUser({
            payload: UPDATE_USER_PAYLOAD,
            user_id : application.user_id,
            token: token
        }).then(function (resp1) {
            if (resp1.body.success === false) {
                reject([resp1]);
                return;
            }
            ApplicationActions.__updateClaim({
                payload: UPDATE_CLAIM_PAYLOAD,
                token: token,
                claim_id : application.claim_id,
            }).then(function (resp2) {
                if (resp2.body.success === false) {
                    reject([resp1, resp2]);
                    return;
                }
                else {
                    resolve([resp1, resp2]);
                }
            }).catch(function(error) {
                reject([error]);
            });
        }).catch(function(error) {
            reject([error]);
        });
    }));
});

ApplicationActions.withdrawApplication.listen(function (token, application) {
    var data = application.values;

    var UPDATE_CLAIM_PAYLOAD = {
        fields: {
            '1381': true
        }
    };

    var UPDATE_USER_PAYLOAD = {
    };

    this.promise(new Promise(function (resolve, reject) {
        ApplicationActions.__updateUser({
            payload: UPDATE_USER_PAYLOAD,
            user_id : application.user_id,
            token: token
        }).then(function (resp1) {
            if (resp1.body.success === false) {
                reject([resp1]);
                return;
            }
            ApplicationActions.__updateClaim({
                payload: UPDATE_CLAIM_PAYLOAD,
                token: token,
                claim_id : application.claim_id,
            }).then(function (resp2) {
                if (resp2.body.success === false) {
                    reject([resp1, resp2]);
                    return;
                }
                else {
                    resolve([resp1, resp2]);
                }
            }).catch(function(error) {
                reject([error]);
            });
        }).catch(function(error) {
            reject([error]);
        });
    }));
});


ApplicationActions.submitResumePage.listen(function (token, application) {
    var data = application.values;

    var UPDATE_USER_PAYLOAD = {
    };

    var UPDATE_CLAIM_PAYLOAD = {
        fields: {
            '1373': data.opt_out,
            '1359': data.resume_internship, //YES/NO, serializes to bool
            '1360': data.resume_companies, // list of strings
            '1363': data.resume_file === undefined ? undefined : JSON.stringify(data.resume_file)
        }
    };

    // ensures no undefined go through. they instead aren't in the PUT
    // should we instead delete it?
    for (var key in UPDATE_CLAIM_PAYLOAD.fields) {
        if (UPDATE_CLAIM_PAYLOAD.fields[key] === undefined) {
            delete UPDATE_CLAIM_PAYLOAD.fields[key];
            // delete UPDATE_CLAIM_PAYLOAD.fields[key] = null;
        }
    }

    // YES/NO field serialization
    var radioQuestions = ['1359'];
    _.forEach(radioQuestions, function(question) {
        if (UPDATE_CLAIM_PAYLOAD.fields[question] === "No") {
            UPDATE_CLAIM_PAYLOAD.fields[question] = false;
        }
        else if (UPDATE_CLAIM_PAYLOAD.fields[question] === "Yes") {
            UPDATE_CLAIM_PAYLOAD.fields[question] = true;
        }
    });

    this.promise(new Promise(function (resolve, reject) {
        ApplicationActions.__updateUser({
            payload: UPDATE_USER_PAYLOAD,
            user_id : application.user_id,
            token: token
        }).then(function (resp1) {
            if (resp1.body.success === false) {
                reject([resp1]);
                return;
            }
            ApplicationActions.__updateClaim({
                payload: UPDATE_CLAIM_PAYLOAD,
                token: token,
                claim_id : application.claim_id,
            }).then(function (resp2) {
                if (resp2.body.success === false) {
                    reject([resp1, resp2]);
                    return;
                }
                else {
                    resolve([resp1, resp2]);
                }
            }).catch(function(error) {
                reject([error]);
            });
        }).catch(function(error) {
            reject([error]);
        });
    }));
});

ApplicationActions.submitVotes.listen(function (token, claim_id, votes) {
    var UPDATE_CLAIM_PAYLOAD = {
        fields: {
            '1394': votes,
        }
    };

    this.promise(new Promise(function (resolve, reject) {
        ApplicationActions.__updateClaim({
            payload: UPDATE_CLAIM_PAYLOAD,
            token: token,
            claim_id : claim_id,
        }).then(function (resp) {
            if (resp.body.success === false) {
                reject(resp);
                return;
            }
            else {
                resolve(resp);
            }
        }).catch(function(error) {
            reject([error]);
        });
    }));
});


ApplicationActions.updateResume.listen(function (token, application) {
    var UPDATE_CLAIM_PAYLOAD = {
        fields: {
            '1363': application.values.resume_file === undefined ? undefined : JSON.stringify(application.values.resume_file)
        }
    };

    this.promise(new Promise(function (resolve, reject) {
        ApplicationActions.__updateClaim({
            payload: UPDATE_CLAIM_PAYLOAD,
            token: token,
            claim_id : application.claim_id,
        }).then(function (resp) {
            if (resp.body.success === false) {
                reject(resp);
                return;
            }
            else {
                resolve(resp);
            }
        }).catch(function(error) {
            reject([error]);
        });
    }));
});

ApplicationActions.submitTravelPage.listen(function (token, application) {
    var data = application.values;

    var format_dob = function(inp) {
        if(inp) {
            var s = inp.split('/');
            var y = s[2] + '-';
            var m = s[1] + '-';
            var d = ('0' + s[0]).slice(-2);
            return y+m+d;
        }
    };

    var ttype = {'0': "walking",
                 '1': "flying",
                 '2': "bus",
                 '3': "driving",
                 '4': "public_transit"};

    var UPDATE_CLAIM_PAYLOAD = {
        fields: {
            '1376': data.travel_receipts === undefined ? undefined : JSON.stringify(data.travel_receipts),
        }
    };

    // should we instead delete it?
    for (var key in UPDATE_CLAIM_PAYLOAD.fields) {
        if (UPDATE_CLAIM_PAYLOAD.fields[key] === undefined) {
            delete UPDATE_CLAIM_PAYLOAD.fields[key];
            // delete UPDATE_CLAIM_PAYLOAD.fields[key] = null;
        }
    }

    var UPDATE_USER_PAYLOAD = {
        shipping_address: {
            line_1: data.reimbursement_address_line1,
            line_2: data.reimbursement_address_line2,
            line_3: data.cheque_name,
            city: data.reimbursement_address_city,
            state_province: data.reimbursement_address_state,
            zip_postal_code: data.reimbursement_address_zipcode,
            country: data.reimbursement_address_country,
            country_code: Country.getCountryCode(data.reimbursement_address_country),
        }
    };

    // properly serialize YES/NO fields into bools

    this.promise(new Promise(function (resolve, reject) {
        ApplicationActions.__updateUser({
            payload: UPDATE_USER_PAYLOAD,
            user_id : application.user_id,
            token: token
        }).then(function (resp1) {
            if (resp1.body.success === false) {
                reject([resp1]);
                return;
            }
            ApplicationActions.__updateClaim({
                payload: UPDATE_CLAIM_PAYLOAD,
                token: token,
                claim_id : application.claim_id,
            }).then(function (resp2) {
                if (resp2.body.success === false) {
                    reject([resp1, resp2]);
                    return;
                }
                else {
                    resolve([resp1, resp2]);
                }
            }).catch(function(error) {
                reject([error]);
            });
        }).catch(function(error) {
            reject([error]);
        });
    }));
});

ApplicationActions.submitWaitlistedTravelPage.listen(function (token, application) {
    var data = application.values;
    var UPDATE_USER_PAYLOAD = {};
    var UPDATE_CLAIM_PAYLOAD = {
        fields: {
            '1386': true,
        }
    };

    // ensures no undefined go through. they instead aren't in the PUT
    // should we instead delete it?
    for (var key in UPDATE_CLAIM_PAYLOAD.fields) {
        if (UPDATE_CLAIM_PAYLOAD.fields[key] === undefined) {
            delete UPDATE_CLAIM_PAYLOAD.fields[key];
            // delete UPDATE_CLAIM_PAYLOAD.fields[key] = null;
        }
    }

    // properly serialize YES/NO fields into bools

    this.promise(new Promise(function (resolve, reject) {
        ApplicationActions.__updateUser({
            payload: UPDATE_USER_PAYLOAD,
            user_id : application.user_id,
            token: token
        }).then(function (resp1) {
            if (resp1.body.success === false) {
                reject([resp1]);
                return;
            }
            ApplicationActions.__updateClaim({
                payload: UPDATE_CLAIM_PAYLOAD,
                token: token,
                claim_id : application.claim_id,
            }).then(function (resp2) {
                if (resp2.body.success === false) {
                    reject([resp1, resp2]);
                    return;
                }
                else {
                    resolve([resp1, resp2]);
                }
            }).catch(function(error) {
                reject([error]);
            });
        }).catch(function(error) {
            reject([error]);
        });
    }));
});


ApplicationActions.submitVotePage.listen(function (token, application) {
    var UPDATE_CLAIM_PAYLOAD = {
        fields: {
            '1394': application.values.votepage_votes,
            '1395': application.values.votepage_hardware,
            '1396': application.values.votepage_learn,
        }
    };

    // ensures no undefined go through. they instead aren't in the PUT
    // should we instead delete it?
    for (var key in UPDATE_CLAIM_PAYLOAD.fields) {
        if (UPDATE_CLAIM_PAYLOAD.fields[key] === undefined) {
            delete UPDATE_CLAIM_PAYLOAD.fields[key];
            // delete UPDATE_CLAIM_PAYLOAD.fields[key] = null;
        }
    }

    this.promise(new Promise(function (resolve, reject) {
        ApplicationActions.__updateClaim({
            payload: UPDATE_CLAIM_PAYLOAD,
            token: token,
            claim_id : application.claim_id,
        }).then(function (resp) {
            if (resp.body.success === false) {
                reject([resp]);
                return;
            }
            else {
                resolve([resp]);
            }
        }).catch(function(error) {
            reject([error]);
        });
    }));
});


module.exports = ApplicationActions;



/*****************
 ** WEBPACK FOOTER
 ** ./js/shared/actions/application-actions.js
 ** module id = 219
 ** module chunks = 0 1 6 9
 **/